module.exports = "/img/1.c837e0.webp";